import { type ComponentPropsConfig } from '../../../utils/codegen';

/**
 * A modal header contains the title of the modal and can contain other React elements such as a close button.
 */
export const componentPropsConfig: ComponentPropsConfig = {
	children: true,
	testId: true,
};

/**
 * THIS SECTION WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 *
 * This component was generated against an existing platform component.
 * If you are seeing lint errors in this file, it means that this file's dependencies have been modified and the component will need to be regenerated.
 *
 * Please view https://hello.atlassian.net/wiki/spaces/ECO/pages/3358130330/How+to+Regenerate+UI+Kit+Components for more information on how to proceed.
 *
 * For further questions, please ping the #help-forge-ui channel.
 *
 * @codegen <<SignedSource::26d470975aee19e1d851ecdde2f80158>>
 * @codegenId #modal-header
 * @codegenCommand yarn workspace @atlassian/forge-ui codegen modal-header
 * @codegenDependency ../../../../../../../design-system/modal-dialog/src/modal-header.tsx <<SignedSource::ea65b8875acc7b9c9341d0157b54020c>>
 * @codegenDependency ../../../../../../../design-system/modal-dialog/src/hooks.tsx <<SignedSource::5062e27591547b31bd9e5702d12d3685>>
 */
/* eslint @repo/internal/codegen/signed-source-integrity: "warn" */
import React from 'react';
import type { RenderFn } from '@atlassian/forge-ui-types';
import { ModalHeader as PlatformModalHeader } from '@atlaskit/modal-dialog';

type PlatformModalHeaderProps = React.ComponentProps<typeof PlatformModalHeader>;

export type ModalHeaderProps = Pick<
  PlatformModalHeaderProps,
  'children' | 'testId'
>;

/**
 * A modal header contains the title of the modal and can contain other React elements such as a close button.
 */
export const ModalHeader = (props: Parameters<RenderFn>[0]): React.JSX.Element => {
  const {
    testId,
  } = props.forgeDoc.props as ModalHeaderProps;
  return (
    <PlatformModalHeader
      children={props.forgeDoc.children.map(c => <React.Fragment key={c.key}>{props.render(c)}</React.Fragment>)}
      testId={testId}
    />
  );
};
/**
 * @codegenEnd
 */
